module.exports = __webpack_public_path__ + "static/media/people.4caf8b90.jpg";